import RowsChild from './RowsChild';

const Rows = (props: any) => {
  return (
    props.imageGadgets &&
    Object.entries(props.imageGadgets).map(
      (imageGadget: any, index: number) => (
        <RowsChild key={index} imageGadget={imageGadget} />
      )
    )
  );
};
export default Rows;
